export enum AttachmentType {
  Picture = 0,
  Writing = 1,
  Miscellaneous = 2,
  Audio = 3,
  Plan = 4,
  PlanSection = 5
}
